<template>
                  <footer class="sticky-footer bg-white">
                <div class="container my-auto">
                    <div class="copyright text-center my-auto">
                        <span>Copyright &copy; Nova Avia {{ new Date().getFullYear() }}</span>
                    </div>
                </div>
            </footer>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator';
@Component({

})
export default class FooterMenu extends Vue {

}
</script>

<style>

</style>